export default __webpack_public_path__ + "static/media/forward.5119b641.svg";